import { Box, Skeleton, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { AnalyticsCard } from 'modules/Analytics/components/AnalyticsCard';

import { CompanyLinesChart } from './CompanyLinesChart';
import { useCompanyColorOf, useCompanyNameOf, useConsolidation } from './consolidation';

type GroupDsoProps = { selectedCompanies: ReadonlyArray<string> };

export const GroupDso = ({ selectedCompanies }: GroupDsoProps) => {
  const { t } = useTranslation();
  const companyNameOf = useCompanyNameOf();
  const companyColorOf = useCompanyColorOf();
  const { groupAnalytics, groupAnalyticsError, isGroupAnalyticsLoading } =
    useConsolidation(selectedCompanies);

  if (groupAnalyticsError)
    return (
      <AnalyticsCard title={t(i18nKeys.ANALYTICS.DSO.TITLE)} panelProps={{ pb: 'space6' }}>
        <Text>{t(i18nKeys.GROUP.ANALYTICS_UNAVAILABLE)}</Text>
      </AnalyticsCard>
    );
  if (isGroupAnalyticsLoading)
    return (
      <AnalyticsCard title={t(i18nKeys.ANALYTICS.DSO.TITLE)} panelProps={{ pb: 'space6' }}>
        <Skeleton h={400} mt="md" radius={8} aria-busy />
      </AnalyticsCard>
    );
  if (!groupAnalytics) return null;

  return (
    <AnalyticsCard title={t(i18nKeys.ANALYTICS.DSO.TITLE)} panelProps={{ pb: 'space6' }}>
      <Box w="100%" h="400px">
        <CompanyLinesChart
          legendTarget="#dso-legend-outlet"
          formatValue={days => t(i18nKeys.ANALYTICS.DAYS_SHORT, { count: days })}
          lines={groupAnalytics.companyDsos.map(({ company, months }) => ({
            company,
            name: companyNameOf(company),
            color: companyColorOf(company),
            months,
          }))}
        />
      </Box>
      <Box id="dso-legend-outlet" />
    </AnalyticsCard>
  );
};
